import { Button, ButtonGroup } from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useTopPanel from 'hooks/useTopPanel';
import { memo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import useAuth from 'hooks/useAuth';
import UnAccepted from './UnAccepted';
import Accepted from './Accepted';

const Money = () => {
  const { setComponent } = useTopPanel();
  const [{ user }] = useAuth();
  const axiosPrivate = useAxiosPrivate();

  const [tabValue, setTabValue] = useState('unaccepted');

  useEffect(() => {
    setComponent(
      <div className='component-title flex gap-4 items-center'>
        Sotuv bo'limi
        <ButtonGroup size='small'>
          <Button
            onClick={() => setTabValue('unaccepted')}
            variant={tabValue == 'unaccepted' ? 'contained' : 'outlined'}
          >
            Qabul qilinmagan
          </Button>
          <Button
            onClick={() => setTabValue('accepted')}
            variant={tabValue == 'accepted' ? 'contained' : 'outlined'}
          >
            Qabul qilingan
          </Button>
        </ButtonGroup>
      </div>
    );
  }, [tabValue, setTabValue]);

  const accountsUrl =
    user?.user?.role_id == 1
      ? '/dictionary/accounts'
      : '/dictionary/selfaccounts';

  const { data: accounts } = useQuery({
    queryKey: [accountsUrl],
    queryFn: async () => {
      const response = await axiosPrivate.get(accountsUrl);
      return response.data?.data;
    },
  });

  return tabValue == 'accepted' ? (
    <Accepted />
  ) : (
    <UnAccepted accounts={accounts} />
  );
};

export default memo(Money);
